import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite } from '@pixi/react';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { gameStore } from '../../../store/gameStore';
import { isMobile } from '../../../core/helpers/isMobile';
import {userInfoStore} from "../../../store/userInfoStore";

const GameSettings = observer(
  ({
    isFullScreen,
    isSoundOn,
    soundIconConfig,
    fullScreenIconConfig,
    burgerIconConfig,
    containerConfigs,
    menuIconsBackgroundConfigs,
  }) => {
    const {
      menuIconsBackground,
      burgerIcon,
      closeFullScreenIcon,
      fullScreenIcon,
      soundOnIcon,
      soundOffIcon,
    } = useMemo(() => {
      return getGameImages();
    }, []);

    return (
      <Container {...containerConfigs}>
        <Sprite
          texture={menuIconsBackground}
          {...menuIconsBackgroundConfigs}
          anchor={0.5}
          alpha={0.5}
          scale={isMobile() ? 0.77 : 0.5}
        />
        <Sprite
          {...burgerIconConfig}
          texture={burgerIcon}
          interactive={!gameStore.isSpinStart && !userInfoStore.isReplay}
          anchor={0.5}
          cursor='pointer'
          scale={isMobile() ? 0.77 : 0.5}
        />
        {fullScreenIconConfig.isShow && (
          <Sprite
            {...fullScreenIconConfig}
            texture={isFullScreen ? closeFullScreenIcon : fullScreenIcon}
            anchor={0.5}
            cursor='pointer'
            scale={isMobile() ? 0.77 : 0.5}
          />
        )}
        <Sprite
          {...soundIconConfig}
          texture={isSoundOn ? soundOnIcon : soundOffIcon}
          interactive
          anchor={0.5}
          cursor='pointer'
          scale={isMobile() ? 0.77 : 0.5}
        />
      </Container>
    );
  }
);
export default GameSettings;
